<script lang="typescript">
    import { chevron } from "./appData";
    import { fly } from "svelte/transition";
    import { push } from "svelte-spa-router";

    export let transitionParams: { y: number; duration: number; delay?: number } = {
        y: 350,
        duration: 600,
    };
    export let isActive: boolean = false;
    export let next: string = "/lens/";

    $: classModifier = isActive ? "active" : "";

    const onClick = () => (isActive ? push(next) : null);
</script>

<button type="button" class={classModifier} on:click={onClick} in:fly={transitionParams}>
    Continue {@html chevron}
</button>

<style>
    button {
        @apply bg-primary-light border-0 text-white border-white w-48 py-2;
        @apply flex items-center justify-center text-xl font-bold rounded-md;
    }

    .active {
        @apply bg-white text-primary;
    }
</style>
